<!-- 日期范围选择组件 -->
<template>
<div>
	<a-range-picker :style="{'width': date_width + 'px',}" @change="onChangeDate" :allowClear="false"
	:locale="locale" 
	:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" />
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
export default {
	name: 'dateRangePicker',
	props: ['date_width','start_time_number','before_number'],
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2022-06-12',
			endTime: '2022-06-23',
		}
	},
	// watch: { // 父组件传过来的值不支持直接修改，所以这里用新的变量接收
	//     before_number(val) { 
	// 		// console.log("-----",val)
	//         this.startTime = this.$getBeforeDay(val) // 获取 x天前的日期
	//     },
	// },
	mounted(){
		this.endTime = this.$getThisDay()
		
		// 有传要获取前x天的数据，就进行获取，如果没有就默认获取当天
		if(this.before_number){
			this.startTime = this.$getBeforeDay(this.before_number) // 获取 x天前的日期
		}
		else {
			this.startTime = this.$getThisDay()
		}
	},
	methods:{
		// 日期选择
		onChangeDate(date, dateString) {
			console.log(date, dateString);
			this.startTime = dateString[0]
			this.endTime = dateString[1]
			
			this.$emit('onGetDate',this.startTime,this.endTime)
		},
	}
}
</script>

<style>
</style>